<template>
  <div class="columns is-multiline">
    <b-field
      v-if="!minimumField"
      class="column is-12 mb-0"
      custom-class="mb-4px"
      :type="error.adresse1 ? 'is-danger' : ''">
      <b-input
        v-model="adresse.adresse1"
        :placeholder="`${$t('creerPanneau.labelChamp.adresseDetail')} 1`"
        :disabled="disabled">
      </b-input>
    </b-field>
    <b-field
      v-if="!minimumField"
      class="column is-12 mb-0"
      custom-class="mb-4px">
      <b-input
        v-model="adresse.adresse2"
        :placeholder="`${$t('creerPanneau.labelChamp.adresseDetail')} 2`"
        :disabled="disabled">
      </b-input>
    </b-field>
    <b-field
      v-if="!minimumField"
      class="column is-12 mb-0"
      custom-class="mb-4px">
      <b-input
        v-model="adresse.adresse3"
        :placeholder="`${$t('creerPanneau.labelChamp.adresseDetail')} 3`"
        :disabled="disabled">
      </b-input>
    </b-field>
    <b-field class="column is-4 mb-0">
      <template slot="label">
        <qd-label :label="$t('creerPanneau.labelChamp.codePostal')" />
      </template>
      <b-input
        v-model="adresse.codePostal"
        :placeholder="$t('creerPanneau.labelChamp.codePostal')"
        :disabled="disabled">
      </b-input>
    </b-field>
    <b-field
      class="column is-4 mb-0"
      :type="error.ville ? 'is-danger' : ''">
      <template slot="label">
        <qd-label :label="$t('creerPanneau.labelChamp.ville')" required/>
      </template>
      <b-input
        v-model="adresse.ville"
        :placeholder="$t('creerPanneau.labelChamp.ville')"
        :disabled="disabled">
      </b-input>
    </b-field>
    <b-field class="column is-4 mb-0">
      <template slot="label">
        <qd-label :label="$t('creerPanneau.labelChamp.pays')" />
      </template>
      <b-input
        v-model="adresse.pays"
        :placeholder="$t('creerPanneau.labelChamp.pays')"
        :disabled="disabled">
      </b-input>
    </b-field>
    <b-field
      v-if="coordonneesRequired"
      class="column is-6 mb-0"
      :type="error.latitude ? 'is-danger' : ''">
      <template slot="label">
        <qd-label :label="$t('creerPanneau.labelChamp.latitude')" :required="coordonneesRequired"/>
      </template>
      <b-input
        v-model.number="adresse.latitude"
        @input="setToCoordonnees('lat', $event)"
        :placeholder="$t('creerPanneau.labelChamp.latitude')"
        :disabled="disabled">
      </b-input>
    </b-field>
    <b-field
      v-if="coordonneesRequired"
      class="column is-6 mb-0"
      :type="error.longitude ? 'is-danger' : ''">
      <template slot="label">
        <qd-label :label="$t('creerPanneau.labelChamp.longitude')" :required="coordonneesRequired"/>
      </template>
      <b-input
        v-model.number="adresse.longitude"
        @input="setToCoordonnees('lng', $event)"
        :placeholder="$t('creerPanneau.labelChamp.longitude')"
        :disabled="disabled">
      </b-input>
    </b-field>
  </div>
</template>

<script>
import QdLabel from '@/components/general/qdLabel.vue';
import { genererObjectErrorAdresse } from '@/services/general/validations';

export default {
  props: {
    adresse: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: () => genererObjectErrorAdresse(),
    },
    minimumField: {
      type: Boolean,
      required: false,
      default: false,
    },
    coordonneesRequired: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  components: {
    QdLabel,
  },
  methods: {
    setToCoordonnees(field, val) {
      if (this.adresse.coordonnees) {
        this.adresse.coordonnees[field] = parseFloat(val);
      }
    }
  }
}
</script>
